import RandingStyle19 from "../../randing/RandingStyle19";

function Randing166({ urlCode, urlCodeSettingId }) {
  const countries = [
    { value: "강서", label: "서울" },
    { value: "광교", label: "수원" },
    { value: "의정부", label: "의정부" },
    { value: "춘천B", label: "춘천" },
    { value: "강릉", label: "강릉" },
    { value: "익산", label: "익산" },
    { value: "군산", label: "군산" },
    { value: "전주A", label: "전주" },
    { value: "천안", label: "천안" },
    { value: "광주", label: "광주" },
    { value: "김해", label: "김해" },
  ];

  return (
    <RandingStyle19
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/166/1-1.gif`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/166/2-1.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/166/3-1.jpg`}
      changedIMG={`${process.env.REACT_APP_CDN_BASE}/images/017/01_241101_03.jpg`} // 스텝 변경되는 이미지
      numberColor="#201c54"
      qOptionColor="blue"
      qOptionColor2="age"
      qTitleColor="#204cec"
      formFieldColor="white"
      audioOn={true}
      passBTN={`${process.env.REACT_APP_CDN_BASE}/images/166/1-2.png`}
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/165/2-2.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/165/2-2.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
      randingNumber="166"
      allCountry={true}
      countries={countries}
    />
  );
}

export default Randing166;
